import axios from 'axios'
import Qs from 'qs'

import { getSelectedLanguage } from '../../helpers/other'
import getToken, { isAwsRequest } from '../../helpers/api'

import { BE_LANGUAGE_VALUE } from '../../constants/language'

const BaseAxiosInstance = axios.create({
  responseType: 'json',
  paramsSerializer: {
    // transforms array to the multiple similar keys with different values:
    serialize: params => Qs.stringify(params, { arrayFormat: 'repeat' })
  }
})

BaseAxiosInstance.interceptors.request.use(async req => {
  const headers = {
    ...req.headers,
    'Accept-Language': BE_LANGUAGE_VALUE[getSelectedLanguage()]
  }
  const token = await getToken()

  // ignore sending Authorization with BE to amazon as it's failing
  // https://stackoverflow.com/questions/31366986/uploading-to-amazon-s3-via-ng-file-upload-error-400
  if (!headers['Authorization'] && !isAwsRequest(req.url) && token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  return {
    ...req,
    headers
  }
})

const api = params =>
  new Promise((resolve, reject) => {
    BaseAxiosInstance(params)
      .then(res => resolve(res))
      .catch(error => reject(error))
  })
export default api
